module.exports = __webpack_public_path__ + "assets/img/ds6.eee5f398.jpg";